import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';

class Header extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        renderAside: PropTypes.func,
    };

    static defaultProps = {
        renderAside: null,
    };

    render() {
        const { children, renderAside } = this.props;
        return (
            <header>
                <Container>
                    <Row className="text-center">
                        <Col
                            className="d-none d-md-block"
                            xs={12}
                            sm={{ size: 6, offset: 3 }}
                        >
                            <h1>{children}</h1>
                        </Col>
                        {!renderAside ? null : (
                            <Col xs={12} sm={3}>
                                {renderAside()}
                            </Col>
                        )}
                    </Row>
                </Container>
            </header>
        );
    }
}

export default Header;
